var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C17.642 16 17.5 18 20 20C21.25 21 22 22.728 22 24.5C22 28 19.314 30 16 30C12.686 30 10 28 10 24.5C10 23 10.5 20.5 12.5 18.5C12.25 20 14 21 14 21C13.25 18.5 15 14.5 18 14Z",
    fill: "#FFA14D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.628 32 28 28 28 21C28 18 27 13 23 9C23.5 12 20.5 13 20.5 13C22 8 18 1 12 0C12.714 4 13 8 8 12C5.5 14 4 17.458 4 21C4 28 9.372 32 16 32ZM16 30C12.686 30 10 28 10 24.5C10 23 10.5 20.5 12.5 18.5C12.25 20 14 21 14 21C13.25 18.5 15 14.5 18 14C17.642 16 17.5 18 20 20C21.25 21 22 22.728 22 24.5C22 28 19.314 30 16 30Z",
    fill: "#FE6F02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon_fire.ce50f7806071458d6d1782257633ac3e.svg";
export { ForwardRef as ReactComponent };